import { ssoInstance } from '@/lib/client/sso-instance';
import { AxiosResponse } from 'axios';

export const signOut = async () => {
  const response = await ssoInstance.post('/api/v1/sso/sign-out', undefined);
  return response.data;
};

export const refreshToken = async (refreshToken: string): Promise<AxiosResponse> => {
  const response = await ssoInstance.get('/api/v1/sso/refresh', {
    headers: {
      Authorization: `Bearer ${refreshToken}`,
    },
  });

  return response.data;
};

export const authAPI = {
  signOut,
  refreshToken,
};
